import { useState } from "react";
import { NavLink as NavLinkRRD, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import dashboardLogo from '../../assets/img/lubeco_smart_without_R-removebg.png';
import './Sidebar.css';
import {
  Collapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
import Logout from "components/logout/Logout";


const Sidebar = (props) => {
  const [collapseOpen, setCollapseOpen] = useState(false);
  const location = useLocation();

  const toggleCollapse = () => {
    setCollapseOpen((prevState) => !prevState);
  };

  const closeCollapse = () => {
    setCollapseOpen(false);
  };

  const createLinks = (routes) => {
    return (
      <>
        {routes.map((prop) => {
          const isActive = location.pathname === prop.layout + prop.path;
          return (
            <NavItem key={prop.path}>
              <NavLink
                to={prop.layout + prop.path}
                tag={NavLinkRRD}
                onClick={closeCollapse}
                className={isActive ? 'active' : ''}
                style={{ fontSize: '14px', fontWeight: 500 }}
              >
                <img src={prop.icon} alt="" className="dashicon" />
                {prop.name}
              </NavLink>
            </NavItem>
          );
        })}
      </>
    );
  };

  const { routes } = props;
  // (Removed unused navbarBrandProps to keep component minimal)

  return (
    <Navbar
      className="navbar-vertical fixed-left navbar_design"
      expand="md"
      id="sidenav-main"
    >
      <Container fluid className="sidebar-container">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {/* Box for background */}
        <div className="logo-box" >
          {/* Image on top */}
          <div className="logo-container" >
            <img
              // className="mt-4"
              src={dashboardLogo}
              alt="Lubeco Smart"
              style={{
                filter: 'drop-shadow(0px 0px 1px rgba(255, 255, 255, 1)) drop-shadow(1px 1px 1px rgba(255, 255, 255, 1))'
              }}
            />
          </div>
        </div>
        <Collapse navbar isOpen={collapseOpen} className="sidebar-collapse">
          <Nav navbar>{createLinks(routes)}</Nav>

        </Collapse>
        <Logout />
        {/* <PoweredBy /> */}
      </Container>
    </Navbar>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    innerLink: PropTypes.string,
    outterLink: PropTypes.string,
    imgSrc: PropTypes.string.isRequired,
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
